import { Image } from '@/components/client';

import { INFO_IMAGE } from '../../constants';

export const InfoImage = () => {
  return (
    <Image
      src={INFO_IMAGE.url}
      alt={INFO_IMAGE.alt}
      width={INFO_IMAGE.width}
      height={INFO_IMAGE.height}
      quality={75}
      loading="lazy"
    />
  );
};

type InfoTextProps = {
  children: React.ReactNode;
};

export const InfoText = ({ children }: InfoTextProps) => {
  return <p id="info-heading">{children}</p>;
};
